export class RecoveryCodes {
  constructor(init: Partial<RecoveryCodes> = {}) {
    this.recoveryCodes = init.recoveryCodes || []
  }

  recoveryCodes: string[]
}
